/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BenchmarkStatus {
    ALL = 'all',
    BENCHMARK = 'benchmark',
    NON_BENCHMARK = 'nonBenchmark',
}
